import React, { Component } from "react";
import axios from "axios";
import { Table } from "antd";
import moment from "moment";
import { ButtonItem } from "../../../../../Components/Items";
import round4Decimals from "../../../../../Components/round4Decimals";

// Desglose, por insumo, de en qué órdenes de compra vigentes sigue pendiente de recibir
// y/o de facturar. Se usa en la fila expandible de InsumosPendientesOrdenDeCompra.js.
class DesgloseOrdenesPendientesInsumo extends Component {
  state = {
    loading: false,
    ordenes: [],
  };

  componentDidMount() {
    this.cargarDesglose();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.insumoId !== this.props.insumoId || prevProps.periodo !== this.props.periodo) {
      this.cargarDesglose();
    }
  }

  async cargarDesglose() {
    if (!this.props.insumoId) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ordenesdecompra/ordenesPendientesPorInsumo",
        {
          empresaId: this.props.empresaId,
          insumoId: this.props.insumoId,
          periodo: this.props.periodo,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState({ ordenes: res.data.ordenes || [] });
      }
    } catch (error) {
      console.error("Error al cargar el desglose de órdenes pendientes:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  verOrden(ordenId) {
    if (this.props.history) {
      this.props.history.push("/panel/verOrdenDeCompra", { id: ordenId });
    }
  }

  render() {
    const columns = [
      {
        title: "Orden",
        key: "orden",
        render: (_, record) => (
          <span>
            {(record.serieOrdenCompra || "") + " - " + record.numero}
          </span>
        ),
      },
      {
        title: "Proveedor",
        dataIndex: "proveedorNombre",
        key: "proveedorNombre",
      },
      {
        title: "Fecha Entrega",
        dataIndex: "fechaEntrega",
        key: "fechaEntrega",
        render: (value) => (value ? moment(value).locale("es").format("ll") : "-"),
      },
      {
        title: "Pendiente Recibir",
        dataIndex: "pendienteRecibir",
        key: "pendienteRecibir",
        align: "right",
        render: (value) => round4Decimals(value || 0).toFixed(4),
      },
      {
        title: "Pendiente Facturar",
        dataIndex: "pendienteFacturar",
        key: "pendienteFacturar",
        align: "right",
        render: (value) => round4Decimals(value || 0).toFixed(4),
      },
      {
        title: "",
        key: "acciones",
        width: 100,
        render: (_, record) => (
          <ButtonItem size="small" onClick={() => this.verOrden(record.ordenId)}>
            Ver Orden
          </ButtonItem>
        ),
      },
    ];

    return (
      <div style={{ padding: "8px 24px", background: "#fafafa" }}>
        <Table
          size="small"
          rowKey={(record) => String(record.ordenId)}
          dataSource={this.state.ordenes}
          columns={columns}
          pagination={false}
          loading={this.state.loading}
          locale={{ emptyText: "Este insumo no tiene órdenes de compra pendientes" }}
        />
      </div>
    );
  }
}

export default DesgloseOrdenesPendientesInsumo;
